<template>
    <Overlay :show="showOverlay">
        <b-row class="pb-2" v-if="showHeading">
            <b-col>
                <h4 v-if="null === id">
                    {{ $t('Page(OrganizationCard):Component(Text):add-new-organization', {type: 'Production Unit'}) }}
                </h4>
                <h4 v-else>
                    {{ $t('Page(OrganizationCard):Component(Text):edit-organization-label', {organization: this.organization.title}) }}
                </h4>
            </b-col>
            <b-col md="6" lg="6">
                <Actions
                    class="float-right"
                    @save="save"
                    @close="close"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6" lg="6">
                <GeneralInfo
                    :show-domain="true"
                    :type="type"
                    :organization="organization"
                    :is-parent-visible="false"
                    :show-valid-from-to-dates="true"
                    :is-location-visible="true"
                    @input="onGeneralInfoChange"
                />
            </b-col>
            <b-col md="6" lg="6">
                <Contacts
                    :selected="organization.contacts"
                    @save="onContactSave"
                    @remove="onRemoveContact"
                />
            </b-col>
        </b-row>
    </Overlay>
</template>

<script>
import {BRow, BCol, BTabs, BTab, BFormGroup, BFormInput, BCard, BFormCheckbox} from 'bootstrap-vue'
import {Actions, GeneralInfo} from "@/views/administration/organization/components";
import Contacts from "@/views/administration/organization/components/Contacts";
import {SupplyChain} from "@core/api";
import {OrganizationType} from "@/libs/supply-chain";
import backendResponse from "@core/mixins/ui/backend-response";
import RegulatedProductStatementDeclaration from "@core/components/product/RegulatedProductStatementDeclaration.vue";
import Overlay from "@core/components/common/Overlay.vue";
import LegislationSettings from "@/views/administration/organization/internal/components/LegislationSettings.vue";

export default {
    mixins: [backendResponse],
    components: {
        LegislationSettings, Overlay, RegulatedProductStatementDeclaration,
        BRow, BCol, BTabs, BTab, BFormGroup, BFormInput, BCard, BFormCheckbox, Actions, GeneralInfo, Contacts,
    },
    props: {
        showHeading: {
            default: true
        },
        isRoot: {
            default: false
        },
        id: {
            default: null
        },
        sid: {
            required: true
        }
    },

    data() {
        return {
            type: OrganizationType.PRODUCTION_UNIT,
            showOverlay: true,

            languages: [],
            defaultSendRequestEmailTemplates: null,
            productStatements: [],
            organizations: [],
            organization: {
                title: null,
                state: null,
                businessRoles: [],
                contacts: [],
                categories: [],
                legalIdentity: null,
                parent: null,
                validFrom: new Date(),
                validTo: new Date('2099-01-01'),
                location: {
                    address: null,
                    city: null,
                    zip: null,
                    coordinates: {
                        latitude: null,
                        longitude: null
                    },
                    unlocode: null
                },
            },
            categories: [],
            contactIdIncrement: 1
        }
    },

    methods: {
        onGeneralInfoChange(info) {
            this.organization.title = info.title;
            this.organization.legalIdentity = info.legalIdentity;
            this.organization.domain = info.domain;
            this.organization.state = info.state;
            this.organization.businessRoles = info.businessRoles;
            this.organization.parent = info.parent;
            this.organization.validFrom = info.validFrom;
            this.organization.validTo = info.validTo;
            this.organization.location = info.location;
        },
        onRemoveContact(contact) {
            let index = this.organization.contacts.findIndex(c => c.id === contact.id);

            if (index >= 0) {
                this.organization.contacts.splice(index, 1);
            }
        },
        onContactSave(id, contact) {
            if (!id) {
                contact.id = (this.contactIdIncrement++) + 'id';
                contact.notPersisted = true;

                this.organization.contacts.push(contact);
            } else {
                let index = this.organization.contacts.findIndex(o => o.id === id);

                if (index !== -1) {
                    let organizationContact = this.organization.contacts[index];
                    organizationContact.name = contact.name;
                    organizationContact.position = contact.position;
                    organizationContact.description = contact.description;
                    organizationContact.communicationChannels = contact.communicationChannels;
                }
            }
        },
        gatherSaveAttributes() {
            let organization = {
                ...this.organization,
                state: this.organization.state ? this.organization.state.id : null,
                contacts: this.organization.contacts.map(c => {
                    if (c.notPersisted) {
                        let contact = {...c};
                        delete contact['id'];
                        delete contact['notPersisted'];
                        return contact;
                    }
                    return c;
                }),
            };

            if (organization.legalIdentity.type) {
                organization.legalIdentity = {
                    type: organization.legalIdentity.type.id,
                    value: organization.legalIdentity.value
                };
            }

            organization.parent = parseInt(this.sid);

            return organization;
        },
        save() {
            this.showOverlay = true;
            const organization = this.gatherSaveAttributes();
            let promise = this.id ? SupplyChain.updateProductionUnit(organization) : SupplyChain.newProductionUnit(organization);
            promise.then(r => {
                this.showDefaultSuccessMessage(
                    this.id ? 'Organization has been successfully updated' : 'Organization has been successfully created'
                );

                if (this.id) {
                    return this.fetch();
                }

                if (r.data.id) {
                    this.onCreate(r.data.id);
                }
            })
                .catch(this.handleBackendError)
                .finally(() => {
                    this.showOverlay = false;
                })

        },
        onCreate(id) {
            this.$router.push({
                name: 'administration-production-units-edit',
                params: {
                    type: this.type,
                    id: id,
                    sid: this.sid,
                }
            });
        },
        close() {
            this.$router.push({
                name: 'administration-supplier-edit',
                params: {id: this.sid}
            });
        },
        fetch() {
            return SupplyChain
                .getOrganizationCard(this.id)
                .then(r => {
                    this.organization = r.data;
                });
        },
    },

    created() {
        if (this.id) {
            this.fetch().then(() => this.showOverlay = false);
        } else {
            setTimeout(() => this.showOverlay = false, 500);
        }
    }
}
</script>
